var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8405 14.8711C16.3954 14.8711 13.6026 17.6639 13.6026 21.109C13.6026 24.5541 16.3954 27.3469 19.8405 27.3469C23.2856 27.3469 26.0784 24.5541 26.0784 21.109C26.0784 17.6639 23.2856 14.8711 19.8405 14.8711ZM11.8203 21.109C11.8203 16.6796 15.4111 13.0889 19.8405 13.0889C24.2699 13.0889 27.8606 16.6796 27.8606 21.109C27.8606 25.5384 24.2699 29.1292 19.8405 29.1292C15.4111 29.1292 11.8203 25.5384 11.8203 21.109Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2434 25.5139C24.5914 25.1659 25.1557 25.1659 25.5037 25.5139L29.3801 29.3903C29.7281 29.7384 29.7281 30.3026 29.3801 30.6506C29.0321 30.9986 28.4678 30.9986 28.1198 30.6506L24.2434 26.7742C23.8954 26.4262 23.8954 25.8619 24.2434 25.5139Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9d71327e25e5dfffed258cc7368956dc.svg";
export { ForwardRef as ReactComponent };